import React from 'react'

const LoadingScreen = () => {
  return (
    <div className='flex items-center justify-center h-screen bg-white'>
      <div className='flex items-center space-x-2'>
        <div className='w-8 h-8 border-4 border-t-4 border-custom-orange border-solid rounded-full animate-spin'></div>
        <span className='text-custom-orange text-lg font-semibold'>
          Loading...
        </span>
      </div>
    </div>
  )
}

export default LoadingScreen
